import React, { useEffect, useState, useRef, useMemo } from "react";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import TableContainer from "../../../components/Common/TableContainer";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  Input,
  Form,
  Button
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Date, NameSurname } from "./contactlistCol";


//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";

import "jspdf-autotable";


import DateModal from "components/Common/DateModal";

import {
  getFeedBack as onGetFeedBack,
  addFeedBack as onAddFeedBack,
  updateFeedBack as onUpdateFeedBack,
  deleteFeedBack as onDeleteFeedBack,
} from "store/contacts/actions";
import { isEmpty } from "lodash";


//redux
import { useSelector, useDispatch } from "react-redux";

const ContactsList = props => {
  const tableRef = useRef(null);

  //meta title
  document.title = "Geri Bildirim | Rehber Ebe ADMIN PANELI";

  const dispatch = useDispatch();
  const [contact, setContact] = useState();
  const [contactEdit, setEditContact] = useState();


  const [getDateModal, setDateModal] = useState(false);

  
  // validation

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      title: (contactEdit && contactEdit.FeedBack_Title) || "",
      desc: (contactEdit && contactEdit.FeedBack_Desc) || "",
      url: (contactEdit && contactEdit.FeedBack_Url) || "",
     
      

    },
    validationSchema: Yup.object({
 
      title: Yup.string(3).required("Başlık Giriniz"),

    }),
    onSubmit: values => {
      if (isEdit) {

        const updateUser = {
          ID: contactEdit.ID,
          FeedBack_Title: values.title,
          FeedBack_Desc: values.desc,
          FeedBack_Url: values.url,
         

        };
        dispatch(onUpdateFeedBack(updateUser));
        setIsEdit(false);
        validation.resetForm();
      } else {
        const newUser = {
          FeedBack_Title: values["title"],
          MailAdress:values["email"],
          FeedBack_Desc:values["desc"],
          FeedBack_Url: values["url"],
         
        };
        // save new user
        dispatch(onAddFeedBack(newUser));
        validation.resetForm();
      }
      toggle();
    },
  });

  const { users } = useSelector(state => ({
    users: state.contacts.feedback,
  }));

  const [userList, setUserList] = useState([]);
  const [modal, setModal] = useState(false);
  const [modalMedia, setModalMedia] = useState(false);

  const [isEdit, setIsEdit] = useState(false);

  const [getSelectDate, setSelectDate] = useState(null);
  const [getSelectDateFinish, setSelectDateFinish] = useState(null);
  const [getFilterData, setFilterData] = useState([]);
  const [getFilterCheck, setFilterCheck] = useState(false);


  const columns = useMemo(
    () => [
      {
        Header: "#",
        Cell: () => {
          return <input type="checkbox" className="form-check-input" />;
        },
      },
      {
        Header: "Foto",
        // accessor: "name",
        disableFilters: true,
        filterable: true,
        accessor: (cellProps) => (
          <>
            {!cellProps.FeedBack_Url ? (
              <div className="avatar-xs">
                {cellProps.FeedBack_Desc != null ? <span className="avatar-title rounded-circle">
                  {cellProps.FeedBack_Desc.charAt(0)}
                </span> : null}
              </div>
            ) : (
              <a rel="noreferrer" href={'https://kampanya.stechomeyazilim.com/Uploads/'  + cellProps.FeedBack_Url} target="_blank">
                <img
                  className=" avatar-xl"
                  src={'https://kampanya.stechomeyazilim.com/Uploads/'  + cellProps.FeedBack_Url}
                  alt=""
                />
              </a>
            )}
          </>
        ),
      },
      {
        Header: "Başlık",
        accessor: "FeedBack_Title",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },

      {
        Header: "Açıklama",
        accessor: "FeedBack_Desc",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },

      {
        Header: "Kullanıcı",
        accessor: "Users.NameSurname",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },
      {
        Header: "Kategori",
        accessor: "Feedback_Category.Feedback_Category_Title",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },
      {
        Header: "Oluşturulma Tarihi",
        accessor: "Created_DateTime",
        filterable: true,
        Cell: cellProps => {
          return <Date {...cellProps} />;
        },
      },


      {
        Header: "_",
        Cell: cellProps => {
          return (
            <div className="d-flex gap-3">

         

           
            </div>
          );
        },
      },
    ],
    []
  );




  useEffect(() => {
    
    if (users && !users.length) {
      dispatch(onGetFeedBack());
      setIsEdit(false);
    }
  }, [dispatch, users]);

  useEffect(() => {
    setContact(users);
    // setIsEdit(false);
  }, [users]);

  useEffect(() => {
    if (!isEmpty(users) && !!isEdit) {
      setContact(users);
      //setIsEdit(false);
    }
  }, [users]);

  const toggle = () => {
    setModal(!modal);
  };


  var node = useRef();
  const onPaginationPageChange = page => {
    if (
      node &&
      node.current &&
      node.current.props &&
      node.current.props.pagination &&
      node.current.props.pagination.options
    ) {
      node.current.props.pagination.options.onPageChange(page);
    }
  };

  //delete customer
  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = users => {
    setContact(users);
    setDeleteModal(true);
  };

  const handleDeleteUser = () => {
    if (contact && contact.ID) {
      dispatch(onDeleteFeedBack(contact.ID));
    }
    onPaginationPageChange(1);
    setDeleteModal(false);
  };

  const handleUserClicks = () => {
    setUserList("");
    setIsEdit(false);
    toggle();
  };


  
  const handleChangeTextFinish = (text) => {

    setSelectDateFinish(text.target.value)

  }
  
  const handleChangeText = (text) => {

      setSelectDate(text.target.value)

    }


  const _onFilterClick = () => {
  
    setFilterData([])

    const dataFilter =  users.filter(x=> x.Created_DateTime >= getSelectDate && x.Created_DateTime <= getSelectDateFinish)
      setFilterData(dataFilter)
      setFilterCheck(true)

      console.log("dataFilter123",dataFilter)
      setDateModal(false)



  // Filtrelenmiş kullanıcıları kullan

  }

  return (
    <React.Fragment>

<DateModal
        onFilterClick = {_onFilterClick}
        show={getDateModal}
        onCloseClick={() => setDateModal(false)}
        handleChange={handleChangeText}
        handleChangeFinish={handleChangeTextFinish}
      />
      

      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Yönetim" breadcrumbItem="Geri Bildirim Listesi" />


    { getFilterCheck == false ?  <Button
    type="button"
    color="success"
    className="btn  mb-2 me-2"
    onClick={(e) => setDateModal(true)}
  >
    <i className="mdi mdi-export me-1" />
   Tarih Aralığı Filtrele
  </Button> : 
  <Button
    type="button"
    color="success"
    className="btn  mb-2 me-2"
    onClick={(e) => setFilterCheck(false)}
  >
    <i className="mdi mdi-export me-1" />
  Bütün Verileri Göster
  </Button>}

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>

                  <TableContainer
                    columns={columns}
                    data={getFilterCheck == true ? getFilterData : users}
                    ref={tableRef}
                    isGlobalFilter={true}
                    
                    handleOrderClicks={handleUserClicks}
                    customPageSize={10}
                    className="custom-header-css"
                  />
              

                  <Modal isOpen={modal} toggle={toggle}>
                    <ModalHeader toggle={toggle} tag="h4">
                      {!!isEdit ? "Düzenle" : "Kullanıcı Ekle"}
                    </ModalHeader>
                    <ModalBody>
                      <Form
                        onSubmit={e => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                      >
                        <Row>
                          <Col xs={12}>



                            <div className="mb-3">
                              <Label className="form-label">Başlık</Label>
                              <Input
                                name="title"
                                label="title"
                                type="text"
                                placeholder="Başlık Giriniz"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.title || ""}
                                invalid={
                                  validation.touched.title &&
                                    validation.errors.title
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.title &&
                                validation.errors.title ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.title}
                                </FormFeedback>
                              ) : null}
                            </div>


                    

                            <div className="mb-3">
                              <Label className="form-label">Açıklama</Label>
                              <Input
                                name="desc"
                                label="desc"
                                type="text"
                                placeholder="Açıklama Giriniz"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.desc || ""}
                                invalid={
                                  validation.touched.desc &&
                                    validation.errors.desc
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.desc &&
                                validation.errors.desc ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.desc}
                                </FormFeedback>
                              ) : null}
                            </div>



                     

                            <div className="mb-3">
                              <Label className="form-label">Geri Bildirim Url</Label>
                              <Input
                                name="url"
                                label="url"
                                type="text"
                                placeholder="Geri Bildirim url"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.url || ""}
                                invalid={
                                  validation.touched.url &&
                                    validation.errors.url
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.url &&
                                validation.errors.url ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.url}
                                </FormFeedback>
                              ) : null}
                            </div>


                  
                           

                          </Col>
                        </Row>
                        <Row>



                          <Col>
                            <div className="text-end">
                              <button
                                type="submit"
                                className="btn btn-success save-user"
                              >
                                Kaydet
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </ModalBody>
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ContactsList);
